import OSTabs from 'components/OSTabs';
import * as React from 'react';
export default {
  OSTabs,
  React
};